<script>    
    export let selection = "C";
    export let colors = [];
    export let strokeWidth = 24;
    export let stroke;
    export let hash;


    import Mondrian from "./Components/Mondrian.svelte"
    import Stripes from "./Components/Stripes.svelte"
    import Circles from "./Components/Circles.svelte"
    import Cross from "./Components/Cross.svelte"
    import Grid from "./Components/Grid.svelte"
    import Triangles from "./Components/Triangles.svelte"
    import Floral from "./Components/Floral.svelte";
    import Floral2 from "./Components/Floral2.svelte";
    import Voronoi from "./Components/Voronoi.svelte";
    import StarBack from "./Components/StarBack.svelte";
    import JoyDivision from "./Components/JoyDivision.svelte";
    import Paisley from "./Components/Paisley2.svelte";
    import BGR from "./Components/bgR.svelte";
    import Jali from "./Components/Jali.svelte";
    import ArabicTiles from "./Components/ArabicTiles.svelte";
    import Camo from "./Components/Camo.svelte";
    import Triangulation from "./Components/Triangulation.svelte";
    import RoyGBiv from "./Components/RoyGBiv.svelte";
    import Flames from "./Components/Flames.svelte";
    import Tiles from "./Components/Tiles.svelte";
    import TruchetTiles from "./Components/TruchetTiles.svelte";
    import Hex from "./Components/Hex.svelte";
    import TextGrid from "./Components/TextGrid.svelte";
    import Knot from "./Components/Knot.svelte";
    import Snowflakes from "./Components/Snowflakes.svelte";
    import CirclePack from "./Components/CirclePack.svelte";


</script>

{#if selection == "A"}
    <Mondrian  bind:hash />
{/if}

{#if selection == "B"}
    <Stripes horizontal={true} />
{/if}

{#if selection == "C"}
    <Stripes horizontal={false} />
{/if}

{#if selection == "D"}
    <Stripes horizontal={false} stripesCount={2} />
{/if}

{#if selection == "E"}
    <Stripes horizontal={true} stripesCount={2} />
{/if}

{#if selection == "F"}
    <Stripes horizontal={false} stripesCount={3} />
{/if}

{#if selection == "G"}
    <Stripes horizontal={true} stripesCount={3} />
{/if}

{#if selection == "H" }
    <Stripes horizontal={false} stripesCount={5} />
{/if}

{#if selection == "I"}
    <Stripes horizontal={true} stripesCount={5} />
{/if}


{#if selection == "J"}
<Circles strokeOnly />
{/if}

{#if selection == "K"}
  <Voronoi/>
{/if}

{#if selection == "L"}
    <!-- <Cross /> -->
    <TruchetTiles tile={(Math.random()*50)+25} shape={1} />
{/if}

{#if selection == "M"}
<CirclePack colors={colors}/>
    <!-- <Cross color1="#FFF" color2="#FFF" color3="#000" color4="#000" /> -->
{/if}

{#if selection == "N"}
    <image xlink:href='{location.origin+"/clouds2.jpg"}' width="100%" height="100%"  />
    
{/if}

{#if selection == "O"}
    <Grid tile={(Math.random()*100)+25} circle={false}/>
{/if}

{#if selection == "P"}

    <image xlink:href='{location.origin+"/bgP.png"}' width="100%" height="100%"  />
{/if}

{#if selection == "Q"}
<Floral2/>
    
{/if}

{#if selection == "R"}
    <BGR />    
{/if}

{#if selection == "S"}
    <image xlink:href='{location.origin+"/bgS.png"}' width="100%" height="100%"  />
{/if}

{#if selection == "T"}
    <image xlink:href='{location.origin+"/bgT.png"}' width="100%" height="100%"  />
{/if}

{#if selection == "U"}
    <image xlink:href='{location.origin+"/bgU.jpg"}' width="100%" height="100%"  />
{/if}
{#if selection == "V"}
    <Triangulation />    
{/if}
{#if selection == "W"}
    <Hex divider={(Math.random()*20)+3} />
{/if}

{#if selection == "X"}
    <Triangles  />
{/if}
{#if selection == "Y"}
    <Floral/>
{/if}

{#if selection == "Z"}
    <Voronoi />
{/if}

{#if selection =="1"}        
    <Grid tile=10 circle={true}/>
{/if}

{#if selection =="2"}    
    <TextGrid tile=25 circle={false}/>
{/if}

{#if selection =="3"}    
    <TruchetTiles tile={(Math.random()*50)+25} />
    
{/if}

{#if selection == "4"}
    <JoyDivision inSVG />
{/if}


{#if selection == "5"}
    <Paisley fill="#000" bg="#777" scale="1" />    
{/if}

{#if selection == "6"}
    <Jali />    
{/if}

{#if selection == "7"}
    <!-- <ArabicTiles />     -->
    <Tiles/>
{/if}

{#if selection == "8"}
    <Camo />    
{/if}

{#if selection == "9"}
    <Knot />    
{/if}

{#if selection == "0"}
    <image xlink:href='{location.origin+"/bg-alhambra.jpg"}' width="100%" height="100%"  />
{/if}




{#if selection == "@"}
<Snowflakes/>
{/if}